<div class="container mt-4">
    <div class="row justify-content-center">
        <div class="col-12 col-md-8">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-2">
                        <div class="col-12 text-center">
                            <i class="fa-solid fa-magnifying-glass mt-2 mb-4"></i>
                            <div class="heading-md mb-4">Find your claim</div>
                            <p class="caption-lg mb-5">Enter the claim reference and student's last name to locate your claim record.</p>
                        </div>
                        <div class="col-12">
                            <form [formGroup]="submissionForm">
                                <div class="row">
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="claimReferenceNumber" class="form-label">Claim Reference</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="claimReferenceNumber"
                                                formControlName="claimReferenceNumber"
                                                appShowFieldErrors="Claim Reference" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="studentLastName" class="form-label">Student's last name</label>
                                            <input type="text" class="form-control" id="studentLastName" formControlName="studentLastName" appShowFieldErrors="Last name" />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="row mb-2">
                            <div class="col-12 text-center">
                                <p class="caption-md mb-5">The claim reference number can be located on the physician claim form.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button class="btn btn-primary mt-5 mb-5" (click)="onSubmit()" (keydown.enter)="onSubmit()" [disabled]="isSaving" [class.btn--waiting]="isSaving">
                                    Find claim
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
